import { GridColDef, GridValueOptionsParams } from "@mui/x-data-grid";
import { IRepeatTaskInstance } from "models/tasks";

const RepeatTaskColumns: GridColDef[] = [
    {
        field: 'name',
        flex: 4,
        minWidth: 80,
        headerName: 'Repeat Task'
    },
    {
        field: 'duration',
        flex: 2,
        headerName: 'Duration',
        type: 'number',
        editable: true,
        align: 'left',
        headerAlign: 'left'
    },
    {
        field: 'responsibilityId',
        flex: 3,
        headerName: 'Responsibility',
        type: 'singleSelect',
        editable: true,
        valueOptions: (params: GridValueOptionsParams<IRepeatTaskInstance>) => {
            return params.row?.responsibilities.map(r => ({
                value: r.id,
                label: r.name
            })) ?? [];
        }
    },
    {
        field: 'resourceId',
        flex: 3,
        headerName: 'Resource',
        type: 'singleSelect',
        valueOptions: (params: GridValueOptionsParams<IRepeatTaskInstance>) => {
            const index = params.row?.responsibilities.findIndex(r => r.id === params.row?.responsibilityId) ?? -1;
            if (index === -1) return [];

            return params.row?.responsibilities[index].resources.map(r => ({
                value: r.id,
                label: r.name
            })) ?? [];
        },
        editable: true
    }
];

export default RepeatTaskColumns;